// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_q2-0";